import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/article/${manga.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={manga.coverImage}
          alt={`${manga.title} - 免费漫画在线阅读`}
          title={`${manga.title} - 韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
        />
        {manga.status === '连载中' && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            连载中
          </span>
        )}
        {manga.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-secondary-500 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            已完结
          </span>
        )}
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 whitespace-nowrap">
          {manga.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 whitespace-nowrap">{manga.author}</p>
        <div className="mt-2 flex items-center justify-between">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs text-foreground-600 font-medium">{manga.rating}</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-eye-line text-foreground-400 text-xs"></i>
            <span className="text-xs text-foreground-500">
              {manga.views >= 10000 ? `${(manga.views / 10000).toFixed(1)}万` : manga.views}
            </span>
          </div>
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {manga.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}